import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'does_the_fac_have_ergonomic_measures_in_place_that_consider_the'

export const dataPointDefinition = {
  retracedId: 'does_the_fac_have_ergonomic_measures_in_place_that_consider_the',
  name: 'Does the facility have ergonomic measures in place that consider the requirements of both women and men? ',
  description:
    'Ergonomic measures seek to minimize risk factors resulting in musculoskeletal disorders, such as the avoidance of lifting heavy items, bending, reaching overhead, pushing and pulling heavy loads, and performing the same or similar tasks repetitively. Requirements for women and men differ based on their unique biological features and sound ergonomic measures consider gender different biological impacts.',
  meta: {},
  fieldTypeId: 'YES_NO',
  type: 'RELATIONAL',
  options: [
    {
      name: 'Yes',
      key: 'YES',
      slcpIndex: 1,
      slcpOptionName: 'yes-no',
    },
    {
      name: 'No',
      key: 'NO',
      slcpIndex: 2,
      slcpOptionName: 'yes-no',
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
        enum: ['YES', 'NO'],
      },
    },
    required: ['value'],
  },
  externalIds: [
    {
      id: 'hs-33',
      version: '1.6.0',
      provider: 'slcp',
    },
  ],
  sortingId: 16020,
  sectionId: '2.2.9.7',
  impactArea: 'Worker Protection',
  impactAreaId: 'WORKER_PROTECTION',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
